<template>
    <div class="collapsible" >
        <div class="trigger">
            <div class="row align-items-center">
                <div class="col-auto">
                    <div class="trigger-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    </div>
                </div>
                <div class="col"> <div class="trigger-content">Mi cuenta</div></div>
                <!--<div class="col-auto touchpad" @click="collapse">
                    <font-awesome-icon v-if="hide" icon="chevron-down" style="color:#fff; height:24px"/>
                    <font-awesome-icon v-else icon="chevron-up" style="color:#fff; height:24px"/>
                </div>-->
            </div>
        </div>
        <!--<div :class="['body',{'hide':hide}]">-->
        <div class="body">
            <div id="micuenta">
                <banner @changeBanner="changeBanner" @changeAvatar="changeAvatar" :item="item"></banner>
                <datos-user :item="item" @updateItem="updateItem"></datos-user>
            </div>
        </div>
    </div>         
</template>

<script>
import banner from '@/components/perfil/banner'
import datosUser from '@/components/perfil/datosUser'

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp,faChevronDown } from "@fortawesome/free-solid-svg-icons";
library.add(faChevronUp);library.add(faChevronDown);

export default {
    name: 'perifl',
    components: {banner,datosUser},
    props:['item'],
    data () {
        return{
            miItem:null,
            hide:false
        }
    },
    mounted(){
        this.miItem = this.item;
    },
    methods:{
        changeBanner(newBanner){
            this.$emit('changeBanner',newBanner)
        },
        changeAvatar(newAvatar){
            this.$emit('changeAvatar',newAvatar)
        },
        updateItem(item){
            this.$emit('updateItem',item);
        },
        collapse(){
            this.hide = !this.hide;
        },
    }
}
</script>


